import { render } from "./BlogElse.vue?vue&type=template&id=0a1534c2"
import script from "./BlogElse.vue?vue&type=script&lang=js"
export * from "./BlogElse.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__